import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { rememberSignInReturnPath } from 'services/Auth/signInReturnPath';

//
// The element of a guarded route for a signed-out user: keeps the page they opened (path, query and fragment) for
// after the sign-in and sends them to the root, where the sign-in starts. No navigation during render.
//
const SignInRedirect = () => {
  const location = useLocation();
  const returnPath = location.pathname + location.search + location.hash;

  useEffect(() => {
    rememberSignInReturnPath(returnPath);
  }, [returnPath]);

  return <Navigate to="/" replace />;
};

export default SignInRedirect;
